import {
  SET_MAP,
  SET_CURRENT_LAT_LNG,
  SET_POS,
  SET_DISTANCE,
  SET_SERVICE,
  SET_CURRENT_DISTANCE,
  SET_CURRENT_SERVICE,
  UNSET_CURRENT_SERVICE,
  RESET_CURRENT_SERVICE,
  SET_ACTIVE_TAB,
  SET_MARKERS,
  SET_SEARCH,
} from '@/storeFinder/context/types';

export default (state, action) => {
  switch (action.type) {
    case SET_MAP:
      return {
        ...state,
        map: action.payload,
      };
    case SET_CURRENT_LAT_LNG: {
      return {
        ...state,
        currentLatLng: action.payload,
      };
    }
    case SET_POS:
      return {
        ...state,
        pos: action.payload,
      };
    case SET_DISTANCE:
      return {
        ...state,
        distance: action.payload,
      };
    case SET_SERVICE:
      return {
        ...state,
        service: action.payload,
      };
    case SET_CURRENT_DISTANCE:
      return {
        ...state,
        currentDistance: action.payload,
      };
    case SET_CURRENT_SERVICE: {
      const currentService = state.currentService.slice();
      if (currentService.indexOf(action.payload) < 0) {
        currentService.push(action.payload);
        currentService.sort();
      }
      return {
        ...state,
        currentService,
      };
    }
    case UNSET_CURRENT_SERVICE: {
      const currentService = state.currentService.slice();
      const actionPayloadIndex = currentService.indexOf(action.payload);
      if (actionPayloadIndex > -1) {
        currentService.splice(actionPayloadIndex, 1);
      }
      return {
        ...state,
        currentService,
      };
    }
    case RESET_CURRENT_SERVICE:
      return {
        ...state,
        currentService: [],
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        tabs: state.tabs.map(tab => {
          tab.isActive = tab.id === action.payload;
          return tab;
        }),
      };
    case SET_MARKERS:
      return {
        ...state,
        markers: action.payload,
      };
    case SET_SEARCH: {
      return {
        ...state,
        currentDistance:
          action.payload.currentDistance !== undefined
            ? action.payload.currentDistance
            : state.currentDistance,
        currentLatLng:
          action.payload.currentLatLng !== undefined
            ? action.payload.currentLatLng
            : state.currentLatLng,
        searched:
          action.payload.searched !== undefined
            ? action.payload.searched
            : state.searched,
      };
    }
    default:
      return { ...state };
  }
};
